/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import Head from "next/head";

import { NoSSR } from "@catchoftheday/cg-components";
import { isAndroidHybridApp } from "@catchoftheday/utilities";

export type BranchIOProps = {
  enabled?: boolean;
  bannerApiKey?: string;
};

export const BranchIO = ({ enabled, bannerApiKey }: BranchIOProps = {}) => {
  if (!enabled || !bannerApiKey) {
    return null;
  }

  return (
    <NoSSR>
      {!isAndroidHybridApp() ? (
        <Head>
          <script
            dangerouslySetInnerHTML={{
              __html: `(function (b, r, a, n, c, h, _, s, d, k) {
            if (!b[n] || !b[n]._q) {
                for (; s < _.length;) {
                    c(h, _[s++]);
                }
                d = r.createElement(a);
                d.defer = true;
                d.src = 'https://cdn.branch.io/branch-2.53.1.min.js';
                k = r.getElementsByTagName(a)[0];
                k.parentNode.insertBefore(d, k);
                b[n] = h;
            }
        })(window, document, 'script', 'branch', function (b, r) {
            b[r] = function () {
                b._q.push([r, arguments]);
            };
        }, {
            _q: [],
            _v: 1
        }, 'addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent logEvent disableTracking'.split(' '), 0);

        branch.init('${bannerApiKey}');`,
            }}
          />
        </Head>
      ) : null}
    </NoSSR>
  );
};
